<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">Home</a></li>
                            <li><a href="#" title="Pages">Gerencial</a></li>
                            <li>Meu CNA - Gestão de Chamados</li>
                        </ul>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Meu CNA - Gestão de Chamados</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="pessoaCNAId">Nome do Responsável</label>
                                    <input type="text" class="form-control" name="nomePessoaCNA" placeholder="Nome do responsável" v-model="filter.nomePessoaCNA" />
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="alunoId">Nome do Aluno</label>
                                    <input type="text" class="form-control" name="nomeAluno" placeholder="Nome do aluno" v-model="filter.nomeAluno" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="idiomaId">Idioma</label>
                                    <select v-select="{ dataitem: 'Idioma', default: 'Selecione' }" v-model="filter.idiomaId" class="form-control" name="idiomaId"></select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="statusAjudaChamadoMeuCNAId">Situação do chamado</label>
                                    <select v-select="{ dataitem: 'StatusAjudaChamadoMeuCNA', default: 'Selecione' }" v-model="filter.statusAjudaChamadoMeuCNAId" class="form-control" name="statusAjudaChamadoMeuCNAId"></select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="assunto">Assunto</label>
                                    <input type="text" class="form-control" name="assunto" placeholder="Assunto" v-model="filter.assunto" />
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="mensagem">Mensagem</label>
                                    <input type="text" class="form-control" name="mensagem" placeholder="Mensagem" v-model="filter.mensagem" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-2">
                                    <label for="dataAberturaStart">Data de Abertura</label>
                                    <input type="text" v-datepicker class="form-control" name="dataAberturaStart" placeholder="__/__/____" v-model="filter.dataAberturaStart" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="dataAberturaEnd">Até</label>
                                    <input type="text" v-datepicker class="form-control" name="dataAberturaEnd" placeholder="__/__/____" v-model="filter.dataAberturaEnd" />
                                </div>

                                <div class="form-group col-md-2">
                                    <label for="dataSituacaoStart">Última Interação</label>
                                    <input type="text" v-datepicker class="form-control" name="dataSituacaoStart" placeholder="__/__/____" v-model="filter.dataSituacaoStart" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="dataSituacaoEnd">Até</label>
                                    <input type="text" v-datepicker class="form-control" name="dataSituacaoEnd" placeholder="__/__/____" v-model="filter.dataSituacaoEnd" />
                                </div>
                            </div>

                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Responsável</th>
                                    <th>Aluno</th>
                                    <th>Idioma</th>
                                    <th>Assunto <i @click="executeOrderBy('Assunto')" class="fa fa-sort"></i></th>
                                    <th>Data de Abertura <i @click="executeOrderBy('DataAbertura')" class="fa fa-sort"></i></th>
                                    <th>Última Interação <i @click="executeOrderBy('DataSituacao')" class="fa fa-sort"></i></th>
                                    <th>Situação <i @click="executeOrderBy('StatusAjudaChamadoMeuCNAId')" class="fa fa-sort"></i></th>

                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.ajudaChamadoMeuCNAId" class="animated fadeIn">
                                    <td>{{ item.ajudaChamadoMeuCNAId }}</td>
                                    <td>{{ item.pessoaCNA.nome }}</td>
                                    <td>{{ item.aluno.pessoaEscola.nome }}</td>
                                    <td>{{ item.idioma.nome }}</td>
                                    <td>{{ item.assunto }}</td>
                                    <td>{{ item.dataAbertura }}</td>
                                    <td>{{ item.dataSituacao }}</td>
                                    <td>{{ item.statusAjudaChamadoMeuCNA.nome }}</td>

                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-success" @click="openEdit({ ajudaChamadoMeuCNAId: item.ajudaChamadoMeuCNAId })">
                                            <i class="fa fa-check-square-o"></i> Interagir 
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="ajudaChamadoMeuCNAId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formEdit from './form-edit'

    export default {
        name: 'ajudachamadomeucna',
        mixins: [base],
        components: { formEdit },
        data() {
            return {

                resources: {
                    filter: 'ajudachamadomeucna',
                    remove: 'ajudachamadomeucna'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.ajudaChamadoMeuCNAId = model.ajudaChamadoMeuCNAId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>